module.exports = __webpack_public_path__ + "img/64.2ac3ee52.jpg";